<template>
  <div class="page page-error">
   <div class="container container-kernel main">
      <b-row>
        <b-col lg="4">
          <h1 class="huge">{{pageName}}</h1>
        </b-col>
        <b-col lg="8">
          <h2 class="h2">{{ $t("errors.e" + pageName + ".title") }} <div id="animation" class="hi-man"></div></h2>
          <p class="h3">{{ $t("errors.e" + pageName + ".description") }}</p>
          <p>{{ $t("errors.webmaster") }}</p>
          <b-btn :to="{name: 'Home' }"  variant="white" data-trackname="errorBtn">{{ $t("buttons.gohome") }}</b-btn>
        </b-col>
      </b-row>
   </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorPages',
  data () {
    return {
      code: ''
    };
  },
  computed: {
    pageName: function () {
      return this.$route.path.substr(-3);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/Error/Index.vue